import { render, staticRenderFns } from "./CloseIncidenceForm.vue?vue&type=template&id=0bb326df&"
import script from "./CloseIncidenceForm.vue?vue&type=script&lang=js&"
export * from "./CloseIncidenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports